module.exports = __webpack_public_path__ + "img/newchris-75.a37f8a07.jpg";